document.addEventListener('DOMContentLoaded', function() {
  const isUK = window.Shopify && Shopify.country === 'GB';
  if (isUK) return; // Only apply to non-UK visitors

  // Function to hide framed options and force Unframed
  function hideFramedOptions() {
    // Desktop: variant-picker
    document.querySelectorAll('variant-picker').forEach(picker => {
      const frameGroup = picker.querySelector('fieldset[data-option="Framing Options"]');
      if (!frameGroup) return;

      // Hide framed options completely
      frameGroup.style.display = 'none';
      frameGroup.style.visibility = 'hidden';
      frameGroup.style.height = '0';
      frameGroup.style.margin = '0';
      frameGroup.style.padding = '0';

      // Force Unframed selection
      const unframedBtn = frameGroup.querySelector('input[value="Unframed"]');
      if (unframedBtn) unframedBtn.checked = true;

      // Ensure Unframed stays selected on Add to Cart
      const addToCartBtn = picker.closest('form')?.querySelector('[type="submit"], .add-to-cart');
      if (addToCartBtn && unframedBtn) {
        addToCartBtn.addEventListener('click', function() {
          unframedBtn.checked = true;
        });
      }
    });

    // Mobile (and any remaining radios): input.opt-btn
    document.querySelectorAll('input.opt-btn').forEach(input => {
      const val = input.value.toLowerCase();

      // Hide framed options
      if (val.includes('frame')) {
        const wrapper = input.closest('label') || input.closest('div');
        if (wrapper) {
          wrapper.style.display = 'none';
          wrapper.style.visibility = 'hidden';
          wrapper.style.height = '0';
          wrapper.style.margin = '0';
          wrapper.style.padding = '0';
        }
      }

      // Force Unframed selection
      if (val.includes('unframed')) {
        input.checked = true;
        const form = input.closest('form');
        if (form) {
          form.addEventListener('submit', function() {
            input.checked = true;
          });
        }
      }
      
      // Ensure Unframed stays selected on Add to Cart
      const form = input.closest('form');
      if (form) {
      const addToCartBtn = form.querySelector('[type="submit"], .add-to-cart');
      if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function() {
      input.checked = true; 
    });
  }
}
    });
  }

  // Run immediately
  hideFramedOptions();

  // Use MutationObserver to catch dynamically loaded variant-picker content
  const observer = new MutationObserver(hideFramedOptions);
  observer.observe(document.body, { childList: true, subtree: true });
});